<!--
  ~ Copyright (C) 2026 DV Bern AG, Switzerland
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as
  ~ published by the Free Software Foundation, either version 3 of the
  ~ License, or (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<div class="admin-modul" flex="auto">
    <div class="tw:w-8/12 tw:mx-auto tw:px-[1.5rem]">
        <h1 class="access-for-all-title" translate>AFA_VERSENDETE_MAILS</h1>
        <div class="view-title">
            <h2 translate>VERSENDETE_MAILS_TITLE</h2>
            <hr class="header" />
        </div>
        @if (showWarning()) {
            <dv-warning
                [text]="'VERSENDETE_MAILS_SUCHE_WARNING' | translate"
            ></dv-warning>
        }
        <dv-versendete-mail-filter
            [(filter)]="filter"
        ></dv-versendete-mail-filter>
        <div class="table-responsive">
            <mat-table
                #table
                [dataSource]="DATA_SOURCE"
                matSort
                class="dv-table"
            >
                <!-- Column zeitpunktversand -->
                <ng-container matColumnDef="zeitpunktVersand">
                    <mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        class="tw:max-w-[20%]"
                    >
                        {{ 'ZEITPUNKTVERSAND_MAIL' | translate }}
                    </mat-header-cell>
                    <mat-cell
                        *matCellDef="let item"
                        data-test="sentTimeMails"
                        class="tw:max-w-[20%]"
                    >
                        {{ item.zeitpunktVersand }}
                    </mat-cell>
                </ng-container>

                <!-- Column empfaengeradresse -->
                <ng-container matColumnDef="empfaengerAdresse">
                    <mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        class="tw:max-w-[30%]"
                    >
                        {{ 'EMPFAENGERADRESSE_MAIL' | translate }}
                    </mat-header-cell>
                    <mat-cell
                        *matCellDef="let item"
                        data-test="sentMailsAdress"
                        class="tw:max-w-[30%]"
                    >
                        <span>{{ item.empfaengerAdresse }}</span>
                        <!-- Hidden Button to open Dialog for screen readers-->
                        <button
                            class="tw:sr-only"
                            [attr.aria-label]="
                                'Details anzeigen für ' + item.name
                            "
                            aria-haspopup="dialog"
                            (click)="$event.stopPropagation(); openMail(item)"
                        ></button>
                    </mat-cell>
                </ng-container>

                <!-- Column betreff -->
                <ng-container matColumnDef="betreff">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'BETREFF_MAIL' | translate }}
                    </mat-header-cell>
                    <mat-cell
                        *matCellDef="let item"
                        data-test="sentMailsSubject"
                    >
                        {{ item.betreff }}
                    </mat-cell>
                </ng-container>

                <mat-header-row
                    *matHeaderRowDef="DISPLAYED_COLUMNS"
                ></mat-header-row>
                <mat-row
                    *matRowDef="let row; columns: DISPLAYED_COLUMNS"
                    tabindex="0"
                    class="pointer-cursor tw:focus:bg-gray-100/30"
                    (click)="openMail(row)"
                    (keydown.enter)="openMail(row)"
                    (keydown.space)="preventDefaultAndOpenMail($event, row)"
                ></mat-row>
            </mat-table>
            <mat-paginator
                [length]="totalResults()"
                [pageSizeOptions]="[10, 25, 100]"
                [pageIndex]="DEFAULT_PAGE"
                [pageSize]="DEFAULT_PAGE_SIZE"
            ></mat-paginator>
        </div>
    </div>
</div>
